import {proposalrequest} from '@mep/pae-commons';
import {Tag} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {PROPOSAL_STATUS_APPEARANCE} from '@/modules/proposalRequest/contants/proposalRequest.status';

const {PROPOSAL_STATUS_ENUM, DRAFT} = proposalrequest;

const ProposalRequestStatus = ({status, full, className, icon, translationKey, hideOnNotMatch, ...props}) => {
  const {t} = useTranslation('proposalRequest');
  if (hideOnNotMatch && !PROPOSAL_STATUS_APPEARANCE[status])
    return null;

  if (!PROPOSAL_STATUS_APPEARANCE[status])
    return (
      <Tag key={status} className={classNames({'w-full': full}, className, 'w-16 text-center')}>
        -
      </Tag>);

  return (
    <Tag
      color={PROPOSAL_STATUS_APPEARANCE[status].color} key={status}
      className={classNames('table-tag-item', {'w-full': full}, 'max-w-44 flex justify-center', className)} {...props}>
      <div className={'flex items-center'}>
        {icon}
        <span className={classNames('flex-grow', {'uppercase': !hideOnNotMatch})}>{t(`${translationKey}.${status}`)}</span>
      </div>
    </Tag>
  );
};

ProposalRequestStatus.propTypes = {
  className: PropTypes.string,
  translationKey: PropTypes.string,
  full: PropTypes.bool,
  hideOnNotMatch: PropTypes.bool,
  status: PropTypes.oneOf(PROPOSAL_STATUS_ENUM),
  icon: PropTypes.any,
};

ProposalRequestStatus.defaultProps = {
  status: DRAFT,
  translationKey: 'proposalRequest.status'
};

export default memo(ProposalRequestStatus);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Status component in a table cell
 * @param {String} status this is the value of the dataIndex of the table (we will ignored in this case)
 * */
export const renderProposalRequestStatus = (status) => {
  return (
    <ProposalRequestStatus status={status}/>
  );
};
